import React from "react";
import Header from "../Shard/Navbar/Header";
import SearchHeading from "./Booking/Search/SearchHeading/SearchHeading";
import SearchResult from "./Booking/Search/SearchResult/SearchResult";
import SearchResult2 from "./Booking/Search/SearchResult/SearchResult2";
import "./Booking.css";

const Booking = ({ isShaw, setIsShaw }) => {
  return (
    <div className="booking">
      <Header isShaw={isShaw} setIsShaw={setIsShaw} />
      <SearchHeading />
      <SearchResult />
      <SearchResult2 />
    </div>
  );
};

export default Booking;
